import { apiClient } from './api';
import type { WorkSites } from '../types/workSites';

/** 연결 앱 — 업무 사이트의 사이트별 현황 · 「바로 이동」(GRK_handbook#16) */

export type LinkTarget = 'project' | 'investment' | 'hire';

export interface SummaryItem {
  key: string;
  label: string;
  value: number | string;
  /** 그 앱 안 경로 — 누르면 그 화면으로 바로 이동 */
  link?: string;
}

export type AppCard =
  | { target: LinkTarget; name: string; state: 'unconfigured' }
  | { target: LinkTarget; name: string; state: 'error'; ok: false }
  | { target: LinkTarget; name: string; state: 'ok'; ok: true; summary: { app: string; updatedAt: string; items: SummaryItem[] } };

export const linkedAppsApi = {
  /** target 을 주면 그 사이트 카드만 */
  summary: (target?: LinkTarget) =>
    apiClient.get<AppCard[]>(target ? `/linked-apps/summary?target=${target}` : '/linked-apps/summary'),
  /** 「업무 사이트」 메뉴 — 권한 없으면 { allowed:false, sites:[] } (403 아님) */
  sites: () => apiClient.get<WorkSites>('/sso/sites'),
  handoff: (target: LinkTarget, next?: string) =>
    apiClient.post<{ url: string }>('/sso/handoff', next ? { target, next } : { target }),
};
